import {
  SHStack,
  SHToggleButtonOptions,
  SHTypography,
} from "@components/design-systems";
import { usePlatformAnalysis } from "@hooks/usePlatformAnalysis";
import { FeesDisplayMode } from "@models/platform-analysis/enums/fee/displayMode";
import { FeesDisplayStyle } from "@models/platform-analysis/enums/fee/displayStyle";
import { FeesPerformanceScope } from "@models/platform-analysis/enums/fee/feesPerformanceScope";
import {
  FeeAnalysisFilterYesNoOptions,
  FeesAnalysisTablePerformanceScopeOptions,
  FeesAnalysisTableViewModeOptions,
} from "@pages/platform-analysis/constant";
import { PlatformAnalysisPortfolioFeeTableToggleButton } from "@pages/platform-analysis/_id/steps/fee/analysis/components/portfolio-fee-table/components/toggle-button";
import { memo } from "react";

interface PortfolioFeesByPlatformTableToolbarProps {
  isAppendix?: boolean;
  disabled?: boolean;
  displayStyle: FeesDisplayStyle;
  displayMode: FeesDisplayMode;
  performanceScope: FeesPerformanceScope;
}

export const PortfolioFeesByPlatformTableToolbar = memo(
  ({
    isAppendix = false,
    displayStyle,
    displayMode,
    performanceScope,
    disabled,
  }: PortfolioFeesByPlatformTableToolbarProps) => {
    const { setPerformanceScope, setDisplayMode, setDisplayStyle } =
      usePlatformAnalysis();

    const onTablePerformanceScopeChange = (scope: FeesPerformanceScope) => {
      setPerformanceScope(scope);
    };

    const onTableDisplayModeChange = (mode: FeesDisplayMode) => {
      setDisplayMode(mode);
    };

    const onTableDisplayStyleChange = (style: FeesDisplayStyle) => {
      setDisplayStyle(style);
    };

    return (
      <SHStack
        paddingBottom={"28px"}
        direction={"row"}
        justifyContent={"space-between"}
      >
        <SHStack direction={"column"}>
          <SHTypography variant="subtitle1" fontWeight={700}>
            SMA portfolio fees by platform
          </SHTypography>
        </SHStack>

        {!isAppendix && (
          <SHStack direction={"row"} gap={2}>
            <PlatformAnalysisPortfolioFeeTableToggleButton
              disabled={disabled}
              options={FeesAnalysisTablePerformanceScopeOptions}
              value={performanceScope}
              onChange={(value) => {
                if (!value) return;
                onTablePerformanceScopeChange(value);
              }}
            />

            <SHToggleButtonOptions
              disabled={disabled}
              options={FeesAnalysisTableViewModeOptions}
              value={displayMode}
              onChange={(_, value) => {
                if (!value) return;
                onTableDisplayModeChange(value);
              }}
            />

            <SHToggleButtonOptions
              disabled={disabled}
              options={FeeAnalysisFilterYesNoOptions}
              value={displayStyle}
              onChange={(_, value) => {
                if (!value) return;
                onTableDisplayStyleChange(value);
              }}
            />
          </SHStack>
        )}
      </SHStack>
    );
  },
);
